<script setup>
import { inject, ref } from 'vue'
import { searchUsers } from '@/services/userService.js'

import TranslationProvider from '@/provider/translations.js'

const { selectedBulkAction } = defineProps(['selectedBulkAction'])
const emit = defineEmits(['closeModal', 'confirm'])

const { modalBulkActionsPayload } = inject('modalBulkActionsPayload')

const loadingSearchUser = ref(false)
const userList = ref([])
const selectedRE = ref(null)
const selectedREA = ref(null)

const getUsers = async (fullSearch = '') => {
  if (fullSearch.length < 3) {
    return
  }

  loadingSearchUser.value = true
  const response = await searchUsers('default-vr', {
    fullSearch: fullSearch,
    page: 1,
    limit: 20,
    excludeData: 0
  })

  userList.value = response.data

  loadingSearchUser.value = false
}

const resetFilters = () => {
  userList.value = []
}

const confirmModal = () => {
  if (!selectedRE.value && !selectedREA.value) {
    return
  }

  modalBulkActionsPayload.value = {
    're': selectedRE.value,
    'rea': selectedREA.value
  }
  emit('confirm')
}
</script>

<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" v-if="selectedBulkAction.title">
        {{ TranslationProvider.getTrans(selectedBulkAction.title) }}
      </h5>
      <h5 class="modal-title" v-else>
        {{ TranslationProvider.getTrans('app.bulk_actions', 'Conferma azione massiva') }}
      </h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        @click="emit('closeModal')"
      ></button>
    </div>
    <div class="modal-body">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="alert alert-warning"
                 v-html="TranslationProvider.getTrans('app.massive_delegate_both_warning')"></div>
          </div>
          <div class="col-12 pb-5">
            <p v-html="TranslationProvider.getTrans('app.ricerca_massiva_delegato_rea')"></p>
            <v-select
              class="select-massive-delegati"
              v-model="selectedREA"
              @search="getUsers"
              :options="userList"
              label="denomination"
              :filterable="false"
              :placeholder="TranslationProvider.getTrans('app.digita_per_cercare')"
              @option:selected="resetFilters"
              @search:blur="resetFilters"
              @search:selected="resetFilters"
              @open="resetFilters"
              clearable
            >
              <template #no-options>
                <div style="opacity: 0.8">{{ TranslationProvider.getTrans('app.no_result_found') }}</div>
              </template>
            </v-select>
          </div>
          <div class="col-12 pb-5">
            <p v-html="TranslationProvider.getTrans('app.ricerca_massiva_delegato_re')"></p>
            <v-select
              class="select-massive-delegati"
              v-model="selectedRE"
              @search="getUsers"
              :options="userList"
              label="denomination"
              :filterable="false"
              :placeholder="TranslationProvider.getTrans('app.digita_per_cercare')"
              @option:selected="resetFilters"
              @search:blur="resetFilters"
              @search:selected="resetFilters"
              @open="resetFilters"
              clearable
            >
              <template #no-options>
                <div style="opacity: 0.8">{{ TranslationProvider.getTrans('app.no_result_found') }}</div>
              </template>
            </v-select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        data-bs-dismiss="modal"
        @click="emit('closeModal')"
      >
        {{ TranslationProvider.getTrans('app.annulla') }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        data-bs-dismiss="modal"
        @click="confirmModal"
        :disabled="!selectedRE && !selectedREA"
      >
        {{ TranslationProvider.getTrans('app.conferma') }}
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
